import { render, staticRenderFns } from "./DashBoardInner.vue?vue&type=template&id=f729974e"
import script from "./DashBoardInner.vue?vue&type=script&lang=js"
export * from "./DashBoardInner.vue?vue&type=script&lang=js"
import style0 from "./DashBoardInner.vue?vue&type=style&index=0&id=f729974e&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports